<template>
  <div id="app">
    <router-view />
    <Footer />
  </div>
</template>

<script>
import Footer from './views/footer'
export default {
  name: 'App',
  components: {
    Footer
  },
  created() {
    if (screen.width <= 1024) {
      window.location.href = window.location.href.replace('www', 'm') // 去移动端页面
    }
  }
}
</script>
<style>
@import "./assets/css/base.css";
@import "./assets/icon/iconfont.css";

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  width: 100%;
  height: 100%;
  background: #fff;
  min-width: 1260px;
  padding-top: 90px;
}

.wapper {
  width: 1260px;
  margin: 0 auto;
}
</style>



// WEBPACK FOOTER //
// src/App.vue